import decodeHtmlEntities from '../../../utils/decodeHtmlEntities';

export const newsText = (value) => decodeHtmlEntities((value || '')
    .replace(/<script\b[^>]*>[\s\S]*?<\/script>/gi, '')
    .replace(/<style\b[^>]*>[\s\S]*?<\/style>/gi, '')
    .replace(/<[^>]*>/g, ' ')).replace(/\s+/g, ' ').trim();

export const newsDescription = (news) => {
    const text = newsText(news.subtitle) || newsText(news.content) || newsText(news.title);

    if (text.length <= 160) return text;

    return `${text.slice(0, 157).replace(/\s+\S*$/, '')}…`;
};

export const newsArticleSchema = (news, slug, image) => ({
    '@context': 'https://schema.org',
    '@type': 'NewsArticle',
    mainEntityOfPage: {
        '@type': 'WebPage',
        '@id': `https://www.antena1.com.br/noticias/${slug}`,
    },
    headline: newsText(news.title),
    ...(image ? { image: [image] } : {}),
    datePublished: news.date,
    dateModified: news.updateDate || news.date,
    ...(news.author ? {
        author: {
            '@type': /^(reuters|antena 1)$/i.test(news.author.trim()) ? 'Organization' : 'Person',
            name: news.author,
        },
    } : {}),
    publisher: {
        '@type': 'Organization',
        name: 'Antena 1',
        logo: { '@type': 'ImageObject', url: 'https://www.antena1.com.br/Logo-default.png' },
    },
    description: newsDescription(news),
});
